import { SchemeProps } from 'app/containers/Builder/props';

import { LegalTypeEnum } from 'app/models';

export const schemeMapper = (scheme: SchemeProps.Form, legalType: LegalTypeEnum | undefined, verified?: boolean) => {
	const wrongType = legalType === LegalTypeEnum.Np ? 'Company' : 'Input';

	return scheme.map((item: any) =>
		item.name === 'inn'
			? item.type === wrongType
				? { ...item, hidden: true, disabled: verified }
				: { ...item, hidden: false, disabled: verified }
			: { ...item, disabled: item.name !== 'email' && verified },
	);
};

export function msToMinutesAndSeconds(ms: number) {
	const minutes = Math.floor(ms / 60000);
	const seconds = ((ms % 60000) / 1000).toFixed(0);

	return `${minutes} : ${Number(seconds) < 10 ? '0' : ''}${seconds}`;
}
